export default "<div class=\"bg-off\">\n  <div class=\"container\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"